import { ConnectedRouter as Router } from "connected-react-router";
import PropTypes from "prop-types";
import { useNavigationCapture } from "./useNavigationCapture";
import setupRouteChangeListener from "./setupRouteChangeListener";
import { useStore } from "react-redux";
import history from "../../client/history";
import { getFeatures } from "../../featuresStore";

const ClientRouter = ({ children }) => {
  const store = useStore();

  setupRouteChangeListener(store, getFeatures()?.decisions);

  useNavigationCapture(history);

  return <Router history={history}>{children}</Router>;
};

ClientRouter.propTypes = {
  children: PropTypes.node.isRequired,
  history: PropTypes.object.isRequired
};

export default ClientRouter;
